import { QueryClient } from '@tanstack/react-query';
import { retryUnlessAuthRequired } from './lib/queryRetry';

/**
 * The app's single react-query client.
 *
 * ⚠ **It lives here rather than in `main.tsx` for a testability reason, not a tidiness one.**
 * `main.tsx` boots the application at module scope, so anything constructed there is
 * unreachable from a test without starting the whole UI. Moving the client out is what lets
 * `queryClient.test.ts` assert that the retry policy is installed — the difference between a
 * policy that is correct and a policy that is *in effect*.
 *
 * 📌 **Still true after BL-146.** That work stopped the API layer from importing the entry point;
 * it did not make `main.tsx` itself importable, because it still calls `createRoot(...).render()`
 * at module scope. Anything that needs to be readable by a test stays out of it.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      // Was `retry: 1`, which retried EVERY failure — including a failure to acquire a token,
      // where the request was never sent and a second attempt costs another full MSAL hidden-
      // iframe timeout for a foregone outcome. See lib/queryRetry.ts.
      retry: retryUnlessAuthRequired,
    },
  },
});
